import { Logo } from 'assets/landing';
import Styles from './inviteLayout.module.scss';

export const InvitationScreenLayout = ({ children }) => {
	return (
		<div className={Styles.container}>
			<img className={Styles.logo} src={Logo} alt='speakeasy-logo' />
			<div className={Styles.content}>
				{children}
			</div>
		</div>
	);
};
